import SCENE_1001 from './scene_1001'
import SCENE_1002 from './scene_1002'
import SCENE_1003 from './scene_1003'
import SCENE_1005 from './scene_1005'
import SCENE_1006 from './scene_1006'
import SCENE_1007 from './scene_1007'
import SCENE_1008 from './scene_1008'
import SCENE_1009 from './scene_1009'
import SCENE_1010 from './scene_1010'
import SCENE_1011 from './scene_1011'
import SCENE_1012 from './scene_1012'
import SCENE_1013 from './scene_1013'
import SCENE_1014 from './scene_1014'
import SCENE_1016 from './scene_1016'
import SCENE_1015 from './scene_1015'
import SCENE_1017 from './scene_1017'
import SCENE_1019 from './scene_1019'


export const gWgts =  {
  1001:SCENE_1001,
  1002:SCENE_1002,
  1003:SCENE_1003,
  1005:SCENE_1005,
  1006:SCENE_1006,
  1007:SCENE_1007,
  1008:SCENE_1008,
  1009:SCENE_1009,
  1010:SCENE_1010,
  1011:SCENE_1011,
  1012:SCENE_1012,
  1013:SCENE_1013,
  1014:SCENE_1014,
  1016:SCENE_1016,
  1015:SCENE_1015,
  1017:SCENE_1017,
  1019:SCENE_1019,
}

export default {}

